import { InputRichTextController } from './input-rich-text.controller'

/* @ngInject */
function inputRichText () {
  return {
    restrict: 'E',
    templateUrl: '/core/directives/input-rich-text/input-rich-text-directive.html?$$REVISION$$',
    controller: InputRichTextController,
    scope: {
      theme: '@',
      placeholder: '<',
      focused: '<',
      alwaysFocused: '<',
      type: '<',
      value: '<',
      hasPrivate: '<',
      hasMark: '<',
      hideSend: '<',
      isMark: '<',
      onTab: '<',
      onSend: '<',
      onMark: '<',
      onChange: '<',
      isPinning: '<',
      hideUndo: '<',
      sendButtonIcon: '<',
      sendButtonText: '<',
      onSendClearValue: '<',
      undoButtonIcon: '<',
      undoButtonText: '<',
      hasDynamicHeight: '<',
      disabled: '<'
    }
  }
}

export { inputRichText }
